// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___Udt5m","title":"styles__title___Ul4BY"};